import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// college-portal-user
import Resources from 'shared/resources/components';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {startLoading, stopLoading} from 'shared/actions/loading';

// pre-req: a user reducer with a "type" property
const mapStateToProps = ({user, loading}) => ({
  user,
  loading: loading.default,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setNavigationAnnouncement,
      startLoading,
      stopLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Resources);
